import { createContext } from "react";
import type { Tracer } from "./tracer";

const defaultTracer: Tracer = {
  addQuery: () => ({ resolve: () => {}, remove: () => {} }),
  start: () => {},
  isSettling: () => false,
  markCold: () => {},
  startedAt: () => undefined,
};

export const NavigationTracerContext = createContext<Tracer>(defaultTracer);
